import config from "@/config";
import SyncLoader from "vue-spinner/src/SyncLoader.vue";
import { mapGetters } from "vuex";

export default {
  props: ["value", "showSearch", "disableToolbar", "salePageShopName", "salePageIsActive"],
  data: function() {
    return {
      config: {
        color: config.color,
      },
      showLang: false,
    };
  },
  computed: {
    langOption() {
      var langOptions = [
        {
          flag: "gb",
          value: "en",
        },
        {
          flag: "th",
          value: "th",
        },
        {
          flag: "la",
          value: "la",
        },
      ];
      return langOptions.filter((el) => {
        if (el.value == "la" && this.pageProfile.type == "nvbb") {
          return false;
        }
        return true;
      });
    },
    ...mapGetters({
      currentLang: "currentLang",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
      theme: "getTheme",
    }),
    merchant: function() {
      return this.value;
    },
  },
  mounted: function() {},
  components: {
    SyncLoader,
  },
  methods: {
    onChangeLang: function(lang) {
      if (["en", "th", "la"].includes(lang)) {
        this.$store.dispatch("setLang", lang);
        if (!this.loadingPageProfile && this.pageProfile && this.$route.query.userid) {
          var data = {
            userid: this.$route.query.userid,
            pageid: this.pageProfile.pageid,
            lang: lang,
          };

          this.$store.dispatch("updatePageProfile", data);
        }
        // location.href = this.$route.fullPath.replace(
        //   "lang=" + this.currentLang,
        //   "lang=" + lang
        // );
      }
    },
  },
};
